import { render, staticRenderFns } from "./profile-image-selector.vue?vue&type=template&id=e8c4fe20"
import script from "./profile-image-selector.vue?vue&type=script&lang=js"
export * from "./profile-image-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports